<template>
  <div class="">
    <div class="card">
      <div class="header">
        <h2>Credentials</h2>
      </div>
      <div class="body">
        <h2 class="card-inside-title">Client Id</h2>
        <p>Client ID입력. 이는 Consumer Key 또는 Api Key로도 불림</p>
        <div class="row clearfix">
          <div class="col-sm-12">
            <div class="form-group">
              <input type="text" class="form-control" v-model="id" />
            </div>
          </div>
        </div>
        <h2 class="card-inside-title">Client Secret</h2>
        <p>Client Secret입력. 이는 Consumer Secret 또는 Api Secret로도 불림</p>
        <div class="row clearfix">
          <div class="col-sm-12">
            <div class="form-group">
              <input type="text" class="form-control" v-model="secret" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right; margin-bottom: 10px">
      <button
        type="button"
        class="btn btn-primary"
        @click="insertCredentialData"
      >
        저장 후 계속
      </button>
    </div>
  </div>
</template>

<script>
// var eventBus = new Vue();

export default {
  name: "tabs",

  data() {
    return {
      id: null,
      secret: null,
    };
  },
  methods: {
    createKeyValue: function (num) {
      console.log("d" + num);
    },
    insertCredentialData() {
      if (this.id == null) {
        alert("Client ID는 필수입니다.");
        return;
      }

      if (this.secret == null) {
        alert("Client Secret은 필수입니다.");
        return;
      }

      var param = {
        apiCode: this.$store.state.devStore.apiCode,
        where: "OAuth2",

        clientId: this.id,
        clientSecret: this.secret,
      };

      this.api.configSchema(param)
        .then((res) => {
          console.log("저장 : ", res);

          // this.$store.state.devStore.title = this.name
          // this.$router.push({name : 'DevActionInput', params: { appId : this.$route.params.appId}})
        })
        .catch(() => alert("오류가 발생했습니다."));
    },
  },

  mounted() {},
  created() {
    if (this.$store.state.devStore.apiData != null) {
      this.id = this.$store.state.devStore.apiData.clientId.replace(/"/gi, "");
      this.secret = this.$store.state.devStore.apiData.clientSecret.replace(
        /"/gi,
        ""
      );
    }
  },
};
</script>
